import { Product } from '@@types'
import { useTranslation } from 'react-i18next'


import { formatPriceAmount } from '@entities/Product/helpers'

import ControlCart from '@features/cart/ui/control/CartControl'
import { FavoriteButton } from '@features/favorite'


import stylesDetail from '@widgets/product-detail/ui/ProductDetail.module.scss'

import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'
import ImageWithBg from '@shared/ui/image-with-bg'
import RatingPreview from '@shared/ui/rating/preview/preview'
import { formatPrice } from '@shared/uttils'
import getNoun from '@shared/uttils/getNoun'

import styles from './StickyCard.module.scss'

interface StickyCardProps {
  product: Product;
}

export default function StickyCard (props: StickyCardProps) {
  const { product } = props
  const { t: tf } = useTranslation('favorites')
  const { t: tp } = useTranslation('product')

  return (
    <div className={styles.root}>
      <ImageWithBg
        className={styles.root__img}
        src={product.preview?.url as string}
      />
      <div className={styles.root__info}>
        <h3 className={styles.root__title}>{product.name}</h3>
        <div className={styles.root__rating}>
          <RatingPreview
            className={stylesDetail['root__rating-star']}
            classNameText={stylesDetail['root__rating-value']}
            value={product.average_rating as number}
          />
          <span className={stylesDetail['root__rating-count']}>
            {product.review_count}{' '}
            {getNoun(
              product.review_count as number,
              tp('productReview.1'),
              tp('productReview.2'),
              tp('productReview.3'),
            )}
          </span>
        </div>
      </div>

      <div className={styles.root__group}>
        <div
          className={cn(
            stylesDetail['root__price-wrapper'],
            styles['root__price'],
          )}
        >
          {product.priceOffer?.price && (
            <div
              className={cn(stylesDetail.root__price, {
                [stylesDetail._accent]: !!product.priceOffer.oldPrice,
              })}
            >
              {formatPrice(product.priceOffer.price)}{' '}
              <span>/ {formatPriceAmount({ priceOffer: product.priceOffer, t: tf })}</span>
            </div>
          )}
          {!!product.priceOffer?.oldPrice && (
            <div
              className={cn(
                stylesDetail['root__old-price'],
                styles['root__old-price'],
              )}
            >
              {formatPrice(product.priceOffer.oldPrice)}
            </div>
          )}
        </div>

        {!!product.stock?.amount && (
          <ControlCart isTablet={false} product={product} />
        )}
        {!product.stock?.amount && (
          <Button size="large" disabled>
            {tp('product.out_of_stock')}
          </Button>
        )}
        <FavoriteButton
          className={styles.root__favorite}
          id={product.id}
          isFavorite={!!product.isFavorite}
          isLarge
          product={product}
        />
      </div>
    </div>
  )
}
